// src/utils/BrowserUtil.ts

class BrowserUtil {

    /** 检测是否为移动端，移动端需要新的排版. */
    public checkMobile() {
        const DEBUG = true
        const TAG = `BrowserUtil.checkMobile() - `
        const agents = ['iphone', 'ipad', 'ipod', 'android', 'linux', 'windows phone']
        const ua = navigator.userAgent.toLowerCase()
        for (let i = 0; i < agents.length; i++) {
            if (ua.indexOf(agents[i]) !== -1) {
                DEBUG && console.log(TAG, `这是移动端:`, ua)
                return true
            }
        }
        return false
    }

}

export let browserUtil = new BrowserUtil()